import { initI18n, getLang } from "./i18n";

function applySupportText(): void {
  const lang = getLang();
  const isZh = lang === "zh";

  const title = document.getElementById("support-title");
  const sub = document.getElementById("support-sub");
  const faqTitle = document.getElementById("support-faq-title");
  const entryTitle = document.getElementById("support-entry-title");
  const taobao = document.getElementById("support-taobao");

  if (title)
    title.textContent = isZh ? "支持与售后" : "Support and After-Sales";
  if (sub) {
    sub.textContent = isZh
      ? "免费版能做什么、完整版差在哪、授权与售后政策都在这里统一说明。新用户建议先走 Quick Start 再联系售后。"
      : "What the free edition can do, what the full version adds, plus license and after-sales policy. New users should complete Quick Start first.";
  }
  if (faqTitle) faqTitle.textContent = isZh ? "常见问题" : "FAQ";
  if (entryTitle) entryTitle.textContent = isZh ? "售后入口" : "Support Entry";

  // 免费版相关（2026-10-19 起七款软件统一为「免费版可用 + 完整版可选」）
  const faq5 = document.getElementById("support-faq-5");
  const faq6 = document.getElementById("support-faq-6");
  const faq7 = document.getElementById("support-faq-7");
  const faq8 = document.getElementById("support-faq-8");
  if (faq5)
    faq5.innerHTML = isZh
      ? "<strong>免费版要授权码吗：</strong>不需要。下载解压就能用，内置演奏者直接出片，从 MIDI 到动画的完整流程都能跑。"
      : "<strong>Does the free edition need a license key:</strong> No. Unzip and run — the bundled performers work out of the box and the whole MIDI-to-animation pipeline runs.";
  if (faq6)
    faq6.innerHTML = isZh
      ? "<strong>免费版和完整版差什么：</strong>免费版装好就能用，内置演奏者能跑通完整流程；自定义角色等进阶功能需要完整版。完整版 ¥98 / 份，一次性买断，解锁全部功能。"
      : "<strong>How is the full version different:</strong> the free edition works out of the box and the bundled performers cover the whole pipeline; custom performers and other advanced features need the full version — $40 USD per app, a one-time purchase that unlocks everything.";
  if (faq7)
    faq7.innerHTML = isZh
      ? '<strong>软件在哪里下载：</strong>到<a href="/free/download.html">下载页</a>拿软件包与预设工程文件：中文用户看百度网盘，海外用户看 Google Drive。'
      : '<strong>Where do I download the apps:</strong> From the <a href="/free/download.html">download page</a> — Baidu Netdisk for mainland China, Google Drive for overseas.';
  if (faq8)
    faq8.innerHTML = isZh
      ? "<strong>以前买过的是不是还是完整版：</strong>是。授权码格式没有变，装上就是完整版；在软件「帮助 → 激活完整版」里填入原授权码即可。"
      : "<strong>I bought before — am I still on the full version:</strong> Yes. The license format has not changed, so the app runs as the full version; enter your existing key under Help → Activate Full Version.";

  const faq1 = document.getElementById("support-faq-1");
  const faq2 = document.getElementById("support-faq-2");
  const faq3 = document.getElementById("support-faq-3");
  const faq4 = document.getElementById("support-faq-4");

  const flowCaption = document.getElementById("support-flow-caption");
  if (flowCaption)
    flowCaption.textContent = isZh
      ? "从机器码到售后补发的四步：机器码 → 下单付款 → 查询/补发授权码 → 换机补发。"
      : "Four steps from machine code to after-sales re-issue: machine code → order and pay → look up or re-issue the license → re-issue for a new device.";

  if (faq1)
    faq1.innerHTML = isZh
      ? "<strong>机器码是什么：</strong>软件内生成的设备标识，用于绑定授权。"
      : "<strong>What is machine code:</strong> Device identifier generated by the software and used for license binding.";
  if (faq2)
    faq2.innerHTML = isZh
      ? '<strong>换机怎么办：</strong>保留订单号，发邮件到 <a href="mailto:highmore9501@163.com">highmore9501@163.com</a>，核实后补发新机器授权。'
      : '<strong>Changed computer:</strong> Keep your order number and email <a href="mailto:highmore9501@163.com">highmore9501@163.com</a> — we will re-issue the license after verification.';
  if (faq3)
    faq3.innerHTML = isZh
      ? '<strong>授权码没查到：</strong>先去查询页，仍无结果再发邮件到 <a href="mailto:highmore9501@163.com">highmore9501@163.com</a>。'
      : '<strong>License not found:</strong> Check the lookup page first, then email <a href="mailto:highmore9501@163.com">highmore9501@163.com</a> if it is still missing.';
  if (faq4)
    faq4.innerHTML = isZh
      ? "<strong>退款说明：</strong>虚拟商品售出后（授权码已生成）原则上不支持退款。"
      : "<strong>Refund policy:</strong> Virtual goods are generally non-refundable after license issuance.";

  const lookupBtn = document.getElementById("support-btn-lookup");
  const buyBtn = document.getElementById("support-btn-buy");
  const quickBtn = document.getElementById("support-btn-quick");

  if (lookupBtn)
    lookupBtn.textContent = isZh
      ? "查询/补发授权码"
      : "Lookup/Re-issue License";
  if (buyBtn) buyBtn.textContent = isZh ? "购买授权" : "Buy License";
  if (quickBtn)
    quickBtn.textContent = isZh ? "返回 Quick Start" : "Back to Quick Start";

  if (taobao)
    taobao.textContent = isZh
      ? "淘宝店：animusic.taobao.com"
      : "Taobao Store: animusic.taobao.com";

  // 客服邮箱：海外买家没有淘宝，邮件是唯一能联系上的方式
  const email = document.getElementById("support-email");
  if (email)
    email.innerHTML = isZh
      ? '客服邮箱：<a href="mailto:highmore9501@163.com">highmore9501@163.com</a>（一般 1–2 个工作日内回复）'
      : 'Support email: <a href="mailto:highmore9501@163.com">highmore9501@163.com</a> (usually a reply within 1–2 business days)';
}

function main(): void {
  initI18n();
  applySupportText();
  document.addEventListener("langchange", applySupportText);
}

main();
